import type { StoreListingDetailPageProps } from '@psl/flows/pdp/StoreListingDetailPageContent';
import { StackNavigationOptions } from '@react-navigation/stack';
import { lazy, useEffect } from 'react';
import { Platform } from 'react-native';
import { isMobileLayout } from '../../components/styles/responsive';
import { wrapLazyNavigatorScreen } from '../../functions/navigation/utils/wrapNavigatorScreen';

const StoreListingDetailPageContent = lazy(() => {
  console.time('[perf] load store listing chunk code');
  return import('./StoreListingDetailPageContent').finally(() => {
    console.timeEnd('[perf] load store listing chunk code');
  });
});

// this is a listing detail page wrapped inside a stack navigator, and
// is intended to be open in anywhere in the app without being inside a show.
// purchase and related features are also supported in this stack.
export const StoreListingDetailPage = wrapLazyNavigatorScreen(
  (props: StoreListingDetailPageProps) => {
    console.time('[perf] store listing page render');
    useEffect(() => {
      console.timeEnd('[perf] store listing page render');
    }, []);
    return <StoreListingDetailPageContent {...props} />;
  },
  ({ route }) =>
    ({
      title: '',
      headerShown: false,
      animationEnabled: isMobileLayout(),
      cardOverlayEnabled: isMobileLayout() ? undefined : true,
      detachPreviousScreen: isMobileLayout() && Platform.OS !== 'web',
      cardStyle: isMobileLayout()
        ? undefined
        : {
            backgroundColor: 'transparent',
          },
      headerBackTitle: '',
      headerBackTitleVisible: false,
      ...route.params.options,
    } as StackNavigationOptions),
);
